import { render, staticRenderFns } from "./SchemaFooter.vue?vue&type=template&id=36e23910&"
import script from "./SchemaFooter.vue?vue&type=script&lang=js&"
export * from "./SchemaFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports